import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import fullpage from 'fullpage.js/dist/fullpage.extensions.min';
import Swal from 'sweetalert2';

UIkit.use(Icons);

window.UIkit = UIkit;
window.fullpage = fullpage;
window.Swal = Swal;